<template>
  <div>
    <v-alert
      v-if="!org.isVerified || !org.is_active"
      style-type="warning"
      text="sentence.organisation_not_verified"
      icon="exclamation-circle"
    />

    <v-organisation-banner
      v-if="statistics"
      :organisation="org"
      :commercials-count="sumCounts(statistics.researches_count)"
      :reviews-count="sumCounts(statistics.sessions_total_count)"
      @edit-information="updateMode = true"
    />

    <div class="row">
      <div class="col-md-5">
        <div
          class="card mb-3"
        >
          <div class="card-header">
            <h5 class="m-0">
              <i class="fa fa-users mr-2"></i>
              {{ $t('phrase.users_in_org', { orgName: org.name }) }}
            </h5>
          </div>
          <div v-if="members">
            <div class="card-body text-danger text-center" v-if="!org.isVerified">
              {{ $t('sentence.organisation_not_verified_members') }}
            </div>
            <table
              v-else-if="members.length > 0"
              class="table table-striped m-0"
            >
              <tr
                v-for="(member, index) in members"
                :key="index"
              >
                <td class="d-flex align-items-center">
                  <div
                    class="img-profile mr-3"
                    :style="{'background-image': getPicture(member.picture)}"
                  />
                  <span>{{ member.full_name_or_username }}</span>
                </td>
              </tr>
            </table>
            <div class="card-body text-muted text-center" v-else>
              {{ $t('phrase.no_members_found') }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="card mb-3">
          <div class="card-header">
            <h5 class="m-0">
              <i class="fa fa-building mr-2"></i>
              {{ $t('phrase.locations_or_branches') }}
            </h5>
          </div>
          <table class="table m-0">
            <thead>
            <tr>
              <th>{{ $t('word.name') }}</th>
              <th>{{ $t('word.address') }}</th>
              <th>{{ $t('word.zip') }}</th>
              <th>{{ $t('word.city') }}</th>
              <th>{{ $t('word.country') }}</th>
            </tr>
            </thead>
            <tr v-for="location in locations" :key="location.zip">
              <td>{{ location.name }}</td>
              <td>{{ location.address || '-' }}</td>
              <td>{{ location.zip }}</td>
              <td>{{ location.city || '-' }}</td>
              <td>{{ location.country || '-' }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <v-organisation-update-modal
      v-if="updateMode"
      @hide-modal="reloadDashboard"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';
import Alert from '@/common/components/Alert.vue';
import OrganisationBanner from '@/organisation/components/OrganisationBanner.vue';
import OrganisationUpdateModal from '@/organisation/components/OrganisationUpdateModal.vue';
import {
  fetchOrganisationLocations,
  fetchOrganisationMembers,
  fetchOrganisationStatistics,
} from '@/organisation/api';

export default {
  name: 'OrganisationDetail',
  components: {
    'v-alert': Alert,
    'v-organisation-banner': OrganisationBanner,
    'v-organisation-update-modal': OrganisationUpdateModal,
  },
  computed: {
    ...mapGetters(['org']),
  },
  data() {
    return {
      statistics: null,
      updateMode: false,
      members: [],
      locations: [],
    };
  },
  methods: {
    sumCounts(counts) {
      if (counts) {
        return counts.tv + counts.radio + counts.ooh;
      }
      return -1;
    },
    getPicture(picturePath) {
      // eslint-disable-next-line global-require
      return `url('${picturePath || require('@/common/assets/img/anonymous.svg')}')`;
    },
    async fetchOrganisationLocations() {
      const response = await fetchOrganisationLocations(this.org.slug);
      this.locations = response.data;
    },
    async fetchOrganisationMembers() {
      const response = await fetchOrganisationMembers(this.org.slug);
      this.members = response.data;
    },
    async fetchOrganisationStatistics() {
      const response = await fetchOrganisationStatistics(this.org.slug);
      this.statistics = response.data;
    },
    reloadDashboard() {
      this.updateMode = false;
    },
  },
  created() {
    setBreadcrumbs('organisation.organisationDetail');
    this.fetchOrganisationStatistics();
    this.fetchOrganisationMembers();
    this.fetchOrganisationLocations();
  },
};
</script>

<style scoped>
.img-profile {
  height: 50px;
  width: 50px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
